module.exports = {
  OK: 'ยืนยัน',
  CANCEL: 'ยกเลิก',
  login_TITLE: 'เข้าสู่ระบบ',
  login_USERNAME: 'ชื่อผู้ใช้:',
  login_PASSWORD: 'รหัสผ่าน:',
  login_LANGUAGE: 'ภาษา:',
  login_SAVEPASSWORD: 'บันทึกรหัสผ่าน',
  login_failure: 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง',
  main_title: 'จัดการตัวแทนขนส่ง',
  main_user: 'ผู้ใช้:',
  main_office: 'บริษัท:',
  main_LOGOUT_TOOLTIP: 'ออกจากระบบ',
  main_CHANGE_PASSWORD_TOOLTIP: 'เปลี่ยนรหัสผ่าน',
  main_REFRESH_TOOLTIP: 'อัปเดตข้อมูลแคช',
  main_HELP_TOOLTIP: 'หน้าช่วยเหลือ',
  main_LOADING_MODULE_STATUS: 'กำลังโหลด {0} ...',
  main_INITIALIZING_STATUS: 'กำลังโหลด ...',
  main_REFRESHING_STATUS: 'กำลังอัปเดตข้อมูลแคช ...',
  password_title: 'เปลี่ยนรหัสผ่าน',
  password_oldPassword: 'รหัสผ่านเดิม:',
  password_newPassword: 'รหัสผ่านใหม่:',
  password_confirmTheNewPassword: 'ยืนยันรหัสผ่านใหม่:',
  password_confirmPassword: 'ป้อนรหัสผ่านอีกครั้ง:',
  password_notMatch: 'รหัสผ่านไม่ตรงกัน',
  password_notCompliant: 'รหัสผ่านต้องมีความยาว 8–20 อักขระ และต้องประกอบด้วยตัวเลข ตัวพิมพ์ใหญ่ และตัวพิมพ์เล็กอย่างละอย่างน้อย',
  password_noChange: 'รหัสผ่านใหม่ต้องไม่เหมือนรหัสผ่านเดิม',
  password_failed: 'การเปลี่ยนรหัสผ่านล้มเหลว โปรดตรวจสอบรหัสผ่านและลองอีกครั้ง',
  PleaseEnterAOldPassword: 'กรุณาป้อนรหัสผ่านเดิม',
  PleaseEnterANewPassword: 'กรุณาป้อนรหัสผ่านใหม่',
  PleaseEnterTheConfirmationPassword: 'กรุณาป้อนยืนยันรหัสผ่านใหม่',
  TheNewPasswordDoesNotMatchTheConfirmedNewPassword: 'รหัสผ่านใหม่และยืนยันรหัสผ่านไม่ตรงกัน',
  TheNewPasswordDoesNotMatchTheOldPassword: 'รหัสผ่านใหม่ต้องไม่เหมือนรหัสผ่านเดิม'
}
